export const TOKEN_SOURCE_F3D6 = 'f3d6';
export const TOKEN_VALID_LENGTH = 64;
export const TOKEN_VALID_LENGTH_F3D6 = 36;
export const CUSTOMER_SUPPORT_URL = 'https://help.williamhill.com/hc/en-gb/articles/36391134467997-Verification-FAQs-for-WH-Irish-customers';
export const UPLOAD_DOCUMENT_URL = 'https://help.williamhill.com/hc/en-gb/requests/new?ticket_form_id=36252558844957';
//# sourceMappingURL=constants.js.map